function bindBadSearchClickEffect() {
  $('a.bad-search').click(function () {
    $(this).toggle('highlight');
  });
}

function init() {
  bindBadSearchClickEffect();
}

$(init);

module.exports = {
  init,
};



// WEBPACK FOOTER //
// ./javascripts/components/products_view.js